import { render, staticRenderFns } from "./dialog-files-list.vue?vue&type=template&id=1bca6d9c&"
import script from "./dialog-files-list.vue?vue&type=script&lang=js&"
export * from "./dialog-files-list.vue?vue&type=script&lang=js&"
import style0 from "./dialog-files-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports